import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BbitWebShopAlgoliaService, BbitWebShopApiService, BbitWebShopService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteMetaDataService, BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { CategoryService } from '../../category/category.service';
import { ItemListHeaderComponent } from '../item-list-header/item-list-header.component';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import { ItemListItemComponent } from './item-list-item/item-list-item.component';
@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ItemListHeaderComponent, FilterBarComponent, AsyncPipe, I18nPipe, ItemListItemComponent],
})
export class ItemListComponent {
  website = inject(BbitWebsiteService);
  api = inject(BbitWebShopApiService);
  algolia = inject(BbitWebShopAlgoliaService);
  private _meta = inject(BbitWebsiteMetaDataService);
  private _activatedRoute = inject(ActivatedRoute);
  private _category = inject(CategoryService);
  private _webshop = inject(BbitWebShopService);

  public layoutShiftHelper = new Array(12).fill(null);
  constructor() {
    this._meta.update({
      title: 'PHX Phoenix',
    });

    this._activatedRoute.queryParams.subscribe((params) => {
      const categorySlugs = params['c'];
      if (categorySlugs) {
        const slugs = categorySlugs.split('>');
        const ids = [];
        if (slugs.length > 0) {
          for (const slug of slugs) {
            const category = this._webshop.getCategories().find((c) => c._slug === slug);
            ids.push(category?._id);
          }
        }

        let i = 0;
        const previousIds = [];
        for (const id of ids) {
          this.algolia.setCategoryFilter(`categories.lvl${i}`, [...previousIds, id].join(' > '));
          previousIds.push(id);
          i++;
        }
      }
    });
  }

  registerItemClick(hit: any, index: number) {
    this.algolia.itemClicked(hit.objectID, index + 1);
  }
}
